import {
  IonRow,
  IonCol,
  IonGrid,
  IonIcon,
  IonButton,
  IonLabel,
} from "@ionic/react";
import React, { PureComponent } from "react";
import "./NewPage.scss";
import { withRouter, RouteComponentProps } from "react-router";
import { SearchResultContainer } from "../../../../web/containers/SearchContainer/SavedSearchcontainer/SearchResultContainer/index";
import {
  Anywhere,
  DryVan,
  Destination,
  Origin,
  DestinationRadius,
  PickupError,
  DropoffError,
  PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
  NO_NETWORK,
  dropdateError1,
  dropdateError2,
  FAVORITE_SEARCH_REMOVED,
  FAVORITE_ALREADY_EXIST_TITLE,
  LIST_FULL_TITLE,
  MESSAGE_TEXT,
  Navigate_Module,
} from "../../../../utils/constants";
import { IONICWrapper, current_device_date_to_iso_format } from '../../../../utils/common'
import { EVENT, SCREEN, TAB } from "../../../../utils/constants.analytics";
import { NewDropDown } from "../../../components/common/DropDown";
import PickupData from "../../../components/Search/PickupData";
import DeliverypData from "../../../components/Search/DeliverypData";
import { logEvent, setScreenName } from "../../../../utils/Analytics";
import { stateItems,getCountryCode} from "../../../../pages/Manage/ManageCapacity/ManagaCapacityUtil";
import { states } from "../../../../utils/states";
import { ToastMessage } from "../../../../utils/ToastMessage";
import { getSearchInputes } from "../../../containers/SearchContainer/searchUtility";
import { CountryCodes as CountryCodesSchema } from "../../../../schemas/Search/Search.schema";
import equal from "fast-deep-equal";
import { Favorite } from '../../../../models/home/favorite.model';
import { CustomModalWeb } from "../../userProfile/CustomModalWeb";
import { compareTwoDateWithoutTimestamp } from "../../../../utils";
import { PreferenceCapacityTypeSetup, PreferenceCapacityValueChange } from "../../Preferences/PreferencesUtil";
import { PreferenceCapacityTypeSelector } from "../../../../selectors/selector";
import { Preferences_CapacityTypePopUp } from "../../Preferences/Preferences_CapacityTypeModal";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { getFormatRoles } from '../../../../../app/utils/formatData';
import { dayjs } from "../../../../utils/Date/DateUtil";
import { IUserDetails } from "../../../../schemas/user";
export interface NewProps extends RouteComponentProps {
  history: any;
  data: any;
  submitForm: any;
  results: any;
  isRecentSearch: boolean;
  totalRecords: number;
  userDetails: IUserDetails;
  isNetworkAvailable: boolean;
  showAlert: any;
  getCountryStateCodes: any;
  countryStateCodes: CountryCodesSchema[];
  getOffSet: any;
  updateFavoriteLoads: any;
  getUpdatedId: any;
  errorData: any;
  clearErrorState: any;
  userPreferences: any;
  updateDateOffset?: (data: {originDateDefaultOffset: string,destinationDateDefaultOffset:string}) => void
}

const currentDate = new Date().toISOString();
let originTimePeriod = 0;
let dstTimePeriod = 0;

let searchPar: any;
class NewPage extends PureComponent<NewProps, any> {
  
  state = {
    TrailerType: DryVan,
    TrailerTypefromResponse:"",
    isOpenPreferenceCapacityTypePopup: false,
    origin: Anywhere,
    originCountry: "",
    originRadius: 100,
    originState: "",
    originPostalCode: "",
    pickUpStartDate: dayjs(currentDate).format("YYYY-MM-DD"),
    pickUpEndDate: currentDate,
    rangeOriginDisable: true,
    destination: Anywhere,
    destinationCountry: "",
    destinationPostalCode: "",
    destinationRadius: 100,
    destinationStates: [],
    dropStartDate: dayjs(currentDate).format("YYYY-MM-DD"),
    dropEndDate: currentDate,
    rangeDisable: true,
    favorite: false,
    showDelivaryfields: false,
    pickUpLocalTime: currentDate,
    dropLocalTime: currentDate,
    isStatesShow: false,
    statesList: stateItems,
    stateError: false,
    pickUpdateError: false,
    dropUpdateError: false,
    destinationError: "",
    originError: "",
    isPickUpTimeError: false,
    isDropTimeError: false,
    isCityError: false,
    pickUpdate: currentDate,
    dropdate: currentDate,
    country: "USA",
    stateOptions: states,
    showResults: this.props.isRecentSearch,
    clearSearch: false,
    criteriaId: "",
    showErrorPopup: false,
    favoriteErrorTitle: '',
    favoriteErrorMessage: '',
    showReloadButton: true,
    searchRequest: {},
    searchParams: {},
    showSearchById: false
  };

  placeSearch = {};

  SelectedOriginVal = "";

  SelectedDestinationVal = "";

  dateUpdated = false;

  dropDateUpdated = false;
  pickUpEndDate = this.state.pickUpEndDate;
  dropEndDate = this.state.dropEndDate;

  componentDidUpdate(prevProps: any, prevState: any) {
    this.compareDateOffsetandDispatch();
    if (
      this.state.destination.length > 0 &&
      this.state.destination !== Anywhere &&
      this.state.TrailerType.length > 0 &&
      (this.state.destinationRadius === 100 ||
        this.state.destinationRadius > 100)
    ) {
      const shouldUpdateRangeDisable =
        (this.state.destinationStates.length === 0 && !this.state.isStatesShow) ||
        (this.state.destinationStates.length > 0 && this.state.isStatesShow);

      if (shouldUpdateRangeDisable && prevState.rangeDisable !== false) {
        this.setState({ rangeDisable: false });
      }
      if (this.state.destinationStates.length === 0 && this.state.isStatesShow && prevState.rangeDisable !== true) {
        this.setState({ rangeDisable: true });
      }
    }
    if (
      this.state.destination.length > 0 &&
      this.state.destination === Anywhere
    ) {
      const newRangeDisable = !(this.state.destinationStates.length > 0 && this.state.isStatesShow);
      if (this.state.rangeDisable !== newRangeDisable || this.state.destinationRadius !== 100) {
        this.setState({
          rangeDisable: newRangeDisable,
          destinationRadius: 100,
        });
      }
    }
    if (!equal(this.props.getOffSet, prevProps.getOffSet)) {
      originTimePeriod = parseInt(this.props?.getOffSet && this.props?.getOffSet?.originDateDefaultOffset || 0);
      dstTimePeriod = parseInt(this.props?.getOffSet && this.props?.getOffSet?.destinationDateDefaultOffset || 0);

      const isRecommendedFlow = (this.props.history.location && this.props.history.location.state && this.props.history.location.state.isRecommendedFlow) || false;
      if (!isRecommendedFlow) {
        this.setDateValues();
      }
    }
    if (!equal(this.props.getUpdatedId, prevProps.getUpdatedId)) {
      this.setState({ criteriaId: this.props.getUpdatedId });
    }
    if (!equal(this.props.errorData, prevProps.errorData)) {
      if (this.props.errorData && this.props.errorData.updateUserSearchHistoryAsFavorite) {
        const favoriteErrorMessage = this.props.errorData.updateUserSearchHistoryAsFavorite.errorMessage;
        const favoriteErrorTitle = favoriteErrorMessage.indexOf(MESSAGE_TEXT) !== -1 ? LIST_FULL_TITLE : FAVORITE_ALREADY_EXIST_TITLE;
        this.setState({ showErrorPopup: true, favoriteErrorTitle, favoriteErrorMessage });
      }
    }
    const locationState = this.props && this.props.location && this.props.location.state as any
    if (
      locationState && locationState.isReloadButton &&
      (!!(JSON.stringify(prevState) === JSON.stringify(this.state))
      || !!(JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)))
      ) {
      this.setState((prevState: any) => {
        return {
          ...prevState,
          ...locationState.params,
          origin: `${locationState.params.origin}, ${locationState.params.originState}`,
          showReloadButton: false,
          showResults: true,
          rangeOriginDisable: false,
          ...(locationState && !locationState.isSimilarRoute) && {...{
            destination: Anywhere,
            destinationCountry: "",
            destinationPostalCode: "",
            destinationRadius: 100,
            destinationStates: [],
            isStatesShow: false,
            statesList: stateItems
          }}
        }
      })
      const state = this.props && this.props.location && this.props.location.state as any || {};
      this.props && this.props.history && this.props.history.replace({ state: {...state,isReloadButton:false,isSimilarRoute:false} })
      searchPar = null;
    }
    if (this.props.userPreferences) {
      const changedCapacityType = PreferenceCapacityTypeSetup(
        this.props.userPreferences
      );
      if (changedCapacityType && changedCapacityType.userPreferenceExists === "No" && 
      this.props?.history?.location?.state?.isGlobalSearch !== true && 
      this.props?.history?.location?.pathname ===Navigate_Module.search && !this.state.TrailerType) {
        this.setState({ isOpenPreferenceCapacityTypePopup: true });
      } 
    }
    const userRole = getFormatRoles();
    if(userRole && userRole.length === 1 )
    {
      if(userRole[0] === "Guest")
      {
      this.setState({ TrailerType: this.state.TrailerType? this.state.TrailerType:DryVan,isOpenPreferenceCapacityTypePopup: false})
      }
    }
    const isShowSearchById = this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.searchById || false;
    isShowSearchById && !this.state.showSearchById &&
      this.setState({ showSearchById: true }, () => {
        this.setDateValues();
        this.clearErrorsState();
        this.handleClear(true, true);
        this.props.clearErrorState();
      });
    !isShowSearchById && this.state.showSearchById && this.setState({ showSearchById: false });
  }

  clearErrorsState = () => {
    this.setState({
      originError: "",
      destinationError: "",
      dropUpdateError: false,
      pickUpdateError: false,
      isPickUpTimeError: false,
      isDropTimeError: false,
      isCityError: false
    });
  }

  handleChange = (event: any) => {
    const { name, value, backClicked, country, postalCode } = event.target;
    let values: any = { [name]: value }
    if (this.state.favorite) values = { ...values, favorite: false };
    if (this.state.criteriaId) values = { ...values, criteriaId: "" };
    this.setState(
      values,
      () => {
        const pickUpStartDate = this.state.pickUpStartDate && this.state.pickUpStartDate.split("T")[0] || '';
        const pickUpEndDate = this.state.pickUpEndDate && this.state.pickUpEndDate.split("T")[0] || '';
        const dropStartDate = this.state.dropStartDate && this.state.dropStartDate.split("T")[0] || '';
        const dropEndDate = this.state.dropEndDate && this.state.dropEndDate.split("T")[0] || '';
        if (name === "pickUpStartDate") {
          this.setState({
            dropUpdateError: this.dateValidation()
          });
        } else if (name === "pickUpEndDate") {
          this.setState({
            dropUpdateError: this.dateValidation()
          });
        } else if (name === "dropStartDate") {
          this.setState({
            dropUpdateError: this.dateValidation() && this.state.dropStartDate?.split("T")[0] !== this.state.dropEndDate
          });
        } else if (name === "dropEndDate") {
          this.setState({
            dropUpdateError: this.dateValidation()
          });
        } else if (
          name === Origin &&
          value.length === 0 &&
          !backClicked &&
          !this.state.clearSearch
        ) {
          this.setState({ originError: PickupError, clearSearch: false });
        } else if (name === Origin && value.length > 0) {
          this.setState({
            originCountry:getCountryCode(country),
            originPostalCode: postalCode,
            originError: "",
            rangeOriginDisable: value === Anywhere,
            dropUpdateError:
              this.state.dropStartDate !== "" && !this.state.rangeOriginDisable && value !== Anywhere &&
                (dropEndDate < pickUpEndDate || dropStartDate < pickUpStartDate) && this.state.destination !== Anywhere
                ? true
                : false,
          });
        } else if (
          name === Destination &&
          value.length === 0 &&
          !backClicked
        ) {
          this.setState({ destinationError: DropoffError, rangeDisable: true });
        } else if (
          name === Destination &&
          value.length > 0
        ) {
          this.setState({
            destinationCountry: getCountryCode(country),
            destinationPostalCode: postalCode,
            destinationError: "", rangeDisable: false,
            dropUpdateError:
              this.state.dropStartDate !== "" && !this.state.rangeOriginDisable &&
                (dropEndDate < pickUpEndDate || dropStartDate < pickUpStartDate)
                ? true
                : false,
          });
        } else if (
          name === DestinationRadius &&
          value > 100
        ) {
          this.setState({ rangeDisable: false });
        }
      });
  };

  handleClear = (origin: boolean, destination: boolean) => {
    let resetValues: any = {};
    if (origin) {
      resetValues = {
        origin: Anywhere,
        originRadius: 100,
        TrailerType: this.state.TrailerTypefromResponse,
        pickUpStartDate: current_device_date_to_iso_format(),
        pickUpEndDate: this.pickUpEndDate,
        rangeOriginDisable: true,
      }
    }
    if (destination) {
      resetValues = {
        ...resetValues,
        destination: Anywhere,
        destinationRadius: 100,
        favorite: false,
        dropStartDate: current_device_date_to_iso_format(),
        dropEndDate: this.dropEndDate,
        rangeDisable: true,
        isStatesShow: false,
        statesList: stateItems,
        destinationStates: []
      }
    }
    if (origin && destination) {
      resetValues = {
        ...resetValues,
        showResults: false,
        clearSearch: true,
      }
    }
    this.setState(resetValues);
  };

  handleCheck = (e: any) => {
    const {
      currentTarget: { checked },
      target: { name },
    } = e;
    this.setState({
      origin:
        name === "originCheck" ? (checked ? Anywhere : "") : this.state.origin,
      destination:
        name === "destinationCheck"
          ? checked
            ? Anywhere
            : ""
          : this.state.destination,
    });
  };

  stateToggle = (e: any) => {
    const {
      currentTarget: { checked },
    } = e;
    this.setState({ isStatesShow: checked });
  };
  compareDateOffsetandDispatch = () =>{
    const originDateDefaultOffset = IONICWrapper.details.getKeyValuePairs("originDateDefaultOffset");
    const destinationDateDefaultOffset = IONICWrapper.details.getKeyValuePairs("destinationDateDefaultOffset");
    if(!equal(this.props.getOffSet, {originDateDefaultOffset,destinationDateDefaultOffset}) &&
      !!originDateDefaultOffset && !!destinationDateDefaultOffset){
        this.props.updateDateOffset && this.props.updateDateOffset({originDateDefaultOffset,destinationDateDefaultOffset})
      }
  }
  componentDidMount() {
    this.compareDateOffsetandDispatch();
    if (this.props.countryStateCodes && this.props.countryStateCodes.length === 0) {
      this.props.getCountryStateCodes();
    }
    const isRecommendedFlow = (this.props.history.location && this.props.history.location.state && this.props.history.location.state.isRecommendedFlow) || false;
    if (!isRecommendedFlow) {
      this.setDateValues();
    }
    const isSimilarRoute = (this.props.history.location?.state?.isSimilarRoute) || false;
    if (isSimilarRoute) {
      this.setState({ rangeDisable: false })
    }
    setScreenName("screen_search_page");
    this.setState(this.props.data);

    // Analytics implementation
    logEvent(EVENT.SV_SEARCH_FILTER, {
      screen: SCREEN.SEARCH_FILTER,
      tab: TAB.NEW,
    });
    if (this.props.userPreferences) {
      const changedCapacityType = PreferenceCapacityTypeSetup(
        this.props.userPreferences
      );
    const updatedTrailerType =  PreferenceCapacityValueChange(changedCapacityType?.value)
     this.setState({ TrailerType: updatedTrailerType, TrailerTypefromResponse : updatedTrailerType });
      if (changedCapacityType && changedCapacityType.userPreferenceExists === "No" && this.props?.history?.location?.state?.isGlobalSearch !== true && this.props?.history?.location?.pathname ===Navigate_Module.search) {
        this.setState({ isOpenPreferenceCapacityTypePopup: true });
      } 
    }
    const userRole = getFormatRoles();
    if(userRole && userRole.length === 1 )
    {
      if(userRole[0] === "Guest")
      {
      this.setState({ TrailerType: DryVan,isOpenPreferenceCapacityTypePopup: false})
      }
    }
    if(this?.props?.history?.location?.state?.searchInput)
    {
      this.setState({pickUpEndDate : this?.props?.history?.location?.state?.searchInput?.pickUpEndDate})
    }
  }

  setErrorValue = (value: boolean, name: string) => {
    if (name === Origin && value === true) {
      this.setState({ originError: PickupError });
    } else if (name === Destination && value === true) {
      this.setState({ destinationError: DropoffError });
    } else if (name === Origin && value === false) {
      this.setState({ originError: "" });
    } else if (name === Destination && value === false) {
      this.setState({ destinationError: "" });
    }
  };

  Apply = (event: any, updateFav: boolean = false) => {
    logEvent("ue_search_request", { page: "Search Page" });
    logEvent(EVENT.UE_SEARCH_SEE_RESULTS, {
      screen: SCREEN.SEARCH_FILTER,
      tab: TAB.NEW,
    });
    event.preventDefault();
    if (!this.state.destination && !this.state.isStatesShow) {
      this.setState({ destinationError: DropoffError });
    } else if (
      this.state.destination !== Anywhere &&
      (this.state.dropStartDate === "" || this.state.dropEndDate === "")
    ) {
      this.setState({ dropUpdateError: true });
    } else {
      /* NETWORK CHECK CONDITION */
      if (this.props.isNetworkAvailable) {
        !this.state.dropUpdateError && this.newSearch(updateFav);
      } else {
        this.props.showAlert({
          isShowAlert: true,
          alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
          alertTitle: NO_NETWORK,
        });
      }
    }
  };

  newSearch = (updateFav: boolean) => {
    const {
      origin,
      originRadius,
      originCountry,
      originPostalCode,
      pickUpStartDate,
      pickUpEndDate,
      TrailerType,
      dropStartDate,
      dropEndDate,
      destinationRadius,
      destination,
      destinationPostalCode
    } = this.state;
    // Generate Query For request
    let pickupLocal = "";
    if (this.state.pickUpLocalTime) {
      pickupLocal = this.state.pickUpLocalTime.split("T")[1];
      const index = pickupLocal.indexOf("-");
      const timezone = index !== -1 ? pickupLocal.slice(index, index + 6) : "-00:00";
      pickupLocal = pickupLocal.slice(0, 12) + timezone;
    }
    let dropLocal = "";
    if (this.state.dropLocalTime) {
      dropLocal = this.state.dropLocalTime.split("T")[1];
      const index = dropLocal.indexOf("-");
      const timezone = index !== -1 ? dropLocal.slice(index, index + 6) : "-00:00";
      dropLocal = dropLocal.slice(0, 12) + timezone;
    }
    let originCity: any = null;
    let originState: any = null;
    let destinationCity: any = null;
    let destinationStates: any = [];
    let destinationCountry = this.state.destinationCountry;
    let newdropStartDate = dropStartDate;
    let newdropEndDate = dropEndDate
    if (origin) {
      let originArray =
        origin.indexOf(",") !== -1 ? origin.split(",") : [origin, ""];
      originCity = originArray[0];
      originState = originArray[1];
    }
    if (destination && !this.state.isStatesShow) {
      let destinationArray =
        destination.indexOf(",") !== -1
          ? destination.split(",")
          : [destination, ""];
      destinationCity = destinationArray[0];
      destinationCity !== Anywhere && destinationStates.push(destinationArray[1] && destinationArray[1].trim());
    }
    if (this.state.isStatesShow) {
      this.state.statesList.map((state: any) => {
        if (state.value && state.value !== "None") {
          return destinationStates.push(state.value)
        };
      });
      destinationCity = "";
      destinationCountry = this.state.country;
    }
    if (
      (this.state.origin === Anywhere &&
        ((this.state.destination === Anywhere && !this.state.isStatesShow) ||
          (this.state.isStatesShow && destinationStates.length === 0)) || (this.state.isStatesShow && destinationStates.length === 0))
    ) {
      ToastMessage.open({
        message: "Select a City State or at least one State for the location.",
        showUndo: false,
      });
    } else if (
      this.state.origin === Anywhere && this.state.isStatesShow
    ) {
      ToastMessage.open({
        message: "Please select a Origin ",
        showUndo: false,
      });
    } else {
      let isDestinationError = false;
      if (this.state.isStatesShow) {
        isDestinationError = false;
      } else {
        isDestinationError = this.state.dropUpdateError || this.state.destinationError !== "" || this.state.isDropTimeError
      }
      if (
        this.state.originError === "" &&
        !this.state.pickUpdateError &&
        !this.state.isCityError &&
        !this.state.isPickUpTimeError &&
        !isDestinationError
      ) {
        if (updateFav) {
          this.setState({ favorite: !this.state.favorite },
            () => {
              const searchParams: any = {
                originCity,
                originCountry,
                originState,
                originPostalCode,
                originradius: originRadius,
                destinationCity,
                destinationStates,
                destinationCountry,
                destinationPostalCode : this.state.isStatesShow ? "" : destinationPostalCode,
                destinationradius: destinationRadius,
                trailertype: TrailerType,
                favouritesearchindicator: this.state.favorite,
                searchdate: new Date().toISOString(),
                dropStartDate:
                  (newdropStartDate &&
                    `${newdropStartDate.split("T")[0]}T${dropLocal}`) ||
                  "",
                dropEndDate:
                  (newdropEndDate && `${newdropEndDate.split("T")[0]}T${dropLocal}`) ||
                  "",
                pickupEndDate:
                  (pickUpEndDate &&
                    `${pickUpEndDate.split("T")[0]}T${pickupLocal}`) ||
                  "",
                pickupStartDate:
                  (pickUpStartDate &&
                    `${pickUpStartDate.split("T")[0]}T${pickupLocal}`) ||
                  "",
                carrierid: this.props.userDetails &&
                this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.carrierId,
                userid: this.props.userDetails &&
                this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.email,
                id: this.state.criteriaId
              };
              const modelF = new Favorite();
              if (!this.state.favorite) {
                ToastMessage.open({
                  message: FAVORITE_SEARCH_REMOVED,
                  showUndo: true,
                  callback: () => {
                    const data = {
                      ...searchParams,
                      favouritesearchindicator: !searchParams.favouritesearchindicator,
                    };
                    this.props.updateFavoriteLoads(
                      modelF.updateFavoriteLoadCheckDuplicate(data),
                      false
                    );
                  },
                });
                this.props.updateFavoriteLoads(
                  modelF.updateFavoriteLoad(searchParams),
                  false
                );
              } else {
                this.props.updateFavoriteLoads(
                  modelF.updateFavoriteLoadCheckDuplicate(searchParams),
                  false)
              }
            });
        } else {
          const searchParams: any = {
            origin: originCity,
            originCountry,
            originState,
            originPostalCode,
            originRadius,
            destination: destinationCity,
            destinationStates,
            destinationCountry,
            destinationPostalCode : this.state.isStatesShow ? "" : destinationPostalCode,
            destinationRadius,
            TrailerType,
            dropStartDate:
              (newdropStartDate &&
                `${newdropStartDate.split("T")[0]}T${dropLocal}`) ||
              "",
            dropEndDate:
              (newdropEndDate && `${newdropEndDate.split("T")[0]}T${dropLocal}`) ||
              "",
            pickUpEndDate:
              (pickUpEndDate &&
                `${pickUpEndDate.split("T")[0]}T${pickupLocal}`) ||
              "",
            pickUpStartDate:
              (pickUpStartDate &&
                `${pickUpStartDate.split("T")[0]}T${pickupLocal}`) ||
              "",
          };
          const searchRequest = getSearchInputes(
            searchParams,
            this.props.userDetails
          );
          this.props.submitForm(searchRequest);
          searchPar = searchParams;
          this.setState({ showResults: true, searchRequest: searchParams, searchParams: searchParams });
        }
      }
    }
  };

  updateLocalCurrentTime = (feildName: string, localTime: string) => {
    if (feildName === "pickUpStartDate") {
      let pickUpStartDate = this.state.pickUpStartDate;
      let pickUpEndDate = this.state.pickUpEndDate;
      const pickUpLocalTime = localTime;
      if (!this.dateUpdated && localTime) {
        pickUpStartDate = pickUpLocalTime.split("T")[0];
        const toDate = new Date(pickUpLocalTime);
        toDate.setDate(toDate.getDate() + originTimePeriod);
        pickUpEndDate = dayjs(toDate).format("YYYY-MM-DD");
        this.dateUpdated = true;
      } else if (pickUpStartDate < pickUpLocalTime.split("T")[0]) {
        pickUpStartDate = pickUpLocalTime.split("T")[0];
      }
      this.setState({ pickUpStartDate, pickUpEndDate, pickUpLocalTime: localTime });
    }
    if (feildName === "dropStartDate") {
      let dropStartDate = this.state.dropStartDate;
      if (this.state.dropStartDate < localTime.split("T")[0]) {
        dropStartDate = localTime.split("T")[0];
      }
      this.setState({ dropLocalTime: localTime, dropStartDate });
    }
  };

  handleStateChange = ({ name, value }: any) => {
    const list = this.state.statesList.map((state: any) => ({
      ...state,
      value: state.name === name ? value.code : state.value,
    }));
    const destinationStates = list
      .filter((state: any) => state.value !== "" && state.value !== "None")
      .map((state: any) => state.value);
    this.setState({
      statesList: list,
      stateError: destinationStates.length === 0,
      rangeDisable: destinationStates.length === 0,
      destinationStates: destinationStates,
      dropUpdateError: compareTwoDateWithoutTimestamp(this.state.pickUpEndDate, this.state.dropEndDate) ? true : false
    });
  };

  handleCountryChange = ({ name, value }: any) => {
    let statesList = this.state.statesList;
    if (this.state.country !== value.code) {
      statesList = stateItems;
    }
    this.setState({ country: value.code, statesList: statesList });
  };

  setDateValues = () => {
    const toDate = new Date(currentDate);
    toDate.setDate(toDate.getDate() + originTimePeriod);
    this.pickUpEndDate = dayjs(toDate).format("YYYY-MM-DD");
    const dropToDate = new Date(currentDate);
    dropToDate.setDate(dropToDate.getDate() + dstTimePeriod);
    this.dropEndDate = dayjs(dropToDate).format("YYYY-MM-DD");
    this.setState({ pickUpEndDate: this.pickUpEndDate, dropEndDate: this.dropEndDate })
  }
  dateValidation = () => {
    const {
      pickUpStartDate,
      pickUpEndDate,
      dropStartDate,
      dropEndDate,
      rangeOriginDisable,
      rangeDisable
    } = this.state;
    return (compareTwoDateWithoutTimestamp(pickUpStartDate, dropStartDate) || compareTwoDateWithoutTimestamp(pickUpEndDate, dropEndDate) || dropStartDate > dropEndDate) && dropStartDate !== "" && !rangeDisable && !rangeOriginDisable;
  }
  closeShowModal = (newCapacityTypeSelected : string) => {
    this.setState({ isOpenPreferenceCapacityTypePopup: false , TrailerType : newCapacityTypeSelected});
  };
  onOk = () => {
    this.setState({ isOpenPreferenceCapacityTypePopup: false });
    this.props.history.push("/app/Preferences", {
      openCapacityType: true,
    });
    setTimeout(() => {
      document &&
        document
          .getElementsByClassName("sni-body-container")[0]
          .scrollTo(0, 5000);
    }, 500);
  };
  render() {
    const getStateOptions = () => {
      if (this.props.countryStateCodes.length > 0 && this.state.country) {
        const filteredCountryStates: any =
          this.props.countryStateCodes.length > 0 &&
          this.props.countryStateCodes.filter((country) => {
            return country.code === this.state.country;
          });
        let states = [...(filteredCountryStates[0] && filteredCountryStates[0].states || [])];
        states.unshift({ code: 'None', name: 'None' })
        return states
      }

      return [];
    };



    const getDeliveryDateError1 = (): string => {
      const { pickUpStartDate, dropStartDate } = this.state;

      return compareTwoDateWithoutTimestamp(pickUpStartDate, dropStartDate) ? dropdateError1 : "";
    }

    const getDeliveryDateError2 = (): string => {
      const { dropEndDate, pickUpEndDate } = this.state;

      return compareTwoDateWithoutTimestamp(pickUpEndDate, dropEndDate) ? dropdateError2 : "";
    }

    const locationState = this.props && this.props.location && this.props.location.state as any
    return (
      <>
        <Preferences_CapacityTypePopUp
          isOpen={this.state.isOpenPreferenceCapacityTypePopup}
          closeModal={(value : string) => this.closeShowModal(value)}
        />
        <div className="search_form_container">
          {!(this.props.history.location?.state?.searchById) && (
            <form className="search-form">
              <IonGrid class="new_page_list search-desktop">
                <IonRow class="capacity-data-feilds">
                  <IonCol size="3">
                    <div className="search-heading">
                      <span>Capacity Type</span>
                    </div>
                  </IonCol>
                  <IonCol size="4">
                    <NewDropDown
                      labelName="Select Mode"
                      TrailerType={this.state.TrailerType}
                      handleChange={this.handleChange}
                    />
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol class="pickup-data-feilds">
                    <PickupData
                      {...this.state}
                      {...this.props}
                      showDate
                      handleChange={this.handleChange}
                      rangeDisabled={this.state.rangeOriginDisable}
                      isDestination={false}
                      defaultValue={Anywhere}
                      useHandler={false}
                      dropDate={this.state.dropdate}
                      setErrorValue={this.setErrorValue}
                      updateLocalCurrentTime={this.updateLocalCurrentTime}
                      handleError={(value: boolean) => {
                        this.setState({ isPickUpTimeError: value });
                      }}
                      handleCheck={this.handleCheck}
                      resetClick={this.handleClear}
                    />
                    <div className="border-new-search"></div>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol class="delivery-data-feilds">
                    <DeliverypData
                      {...this.state}
                      showDate
                      isSearch={true}
                      errorToBeShow={getDeliveryDateError1()}
                      errorMessage2={getDeliveryDateError2()}
                      handleChange={this.handleChange}
                      rangeDisabled={this.state.rangeDisable}
                      platform="desktop"
                      defaultValue={Anywhere}
                      isDestination
                      useHandler={false}
                      pickUpDateValue={this.state.pickUpdate}
                      handleCheck={this.handleCheck}
                      setErrorValue={this.setErrorValue}
                      updateLocalCurrentTime={this.updateLocalCurrentTime}
                      handleError={(value: boolean) => {
                        this.setState({ isDropTimeError: value });
                      }}
                      stateToggle={this.stateToggle}
                      handleStateChange={this.handleStateChange}
                      countries={this.props.countryStateCodes}
                      handleCountryChange={this.handleCountryChange}
                      options={getStateOptions()}
                      resetClick={this.handleClear}
                    />
                  </IonCol>
                </IonRow>
                <IonRow class="footer-row">
                  <IonCol class="ion-align-self-center">
                    <span
                      className="footer-link"
                      onClick={() => this.handleClear(true, true)}
                      data-testid="clearButton"
                    >
                      <IonIcon src="assets/icon/Delete_bin.svg" />{" "}
                      <IonLabel class="add-to-fav">Clear</IonLabel>
                    </span>
                     <span
                      className="footer-link"
                      onClick={event => {
                        this.Apply(event, true);
                      }}
                    >
                      <span
                      data-testid="fav-click2"
                      className={this.state.favorite ? "fav-star" : "eye-icon"}
                      >{" "}
                      </span>
                      <span>{this.state.favorite ? "Unfavorite" : "Favorite"}</span>
                    </span> 
                    <IonButton
                      onClick={event => this.Apply(event, false)}
                      data-testid="apply-mobile"
                    >
                      Search
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </form>
          )}
          <div
            data-testid="error-state"
            onClick={() => {
              this.setState({ showErrorPopup: false, favorite: false });
              this.props.clearErrorState();
            }}
          >
            <CustomModalWeb
              isModalOpen={this.state.showErrorPopup}
              title={this.state.favoriteErrorTitle}
              message_content={this.state.favoriteErrorMessage}
              buttons={[{ title: "ok", callback: () => {} }]}
            />
          </div>
          <SearchResultContainer
            {...(locationState ? locationState.params : {})}
            {...this.state.searchParams}
            {...this.state.searchRequest}
            {...this.props}
            results={this.props?.results?.__carrier_state?.searchLoads}
            {...this.props.history}
            searchNewInput={searchPar}
            showResults={this.state.showResults}
          />
        </div>
      </>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  userPreferences: PreferenceCapacityTypeSelector(),
});
export { NewPage };
export default withRouter(connect(mapStateToProps)(NewPage));